<template>
    <div class="min-h-80">
        <div
            class="steps mt-8 lg:mt-16 container px-4 mx-auto text-center relative"
        >
            <ul class="flex p-0 m-0 w-full">
                <li class="mx-2 text-left">
                    <router-link :to="{ name: 'checkout cart' }"
                        >{{ data.translations.cart }}
                    </router-link>
                </li>
                <li class="mx-2">
                    <router-link
                        :to="{ name: 'checkout addresses' }"
                        :event="cart.isEmpty ? '' : 'click'"
                        >{{ data.translations.addresses }}
                    </router-link>
                </li>
                <li class="mx-2 text-right">
                    <router-link
                        :to="{ name: 'checkout payment' }"
                        :event="cart.isEmpty ? '' : !cart.email ? '' : 'click'"
                    >
                        {{ data.translations.payment }}
                    </router-link>
                </li>
            </ul>
            <div class="meter">
                <vue-progress-bar />
            </div>
            <loading
                class="mt-40 md:mt-48 h-32"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="false"
            />
        </div>
        <keep-alive exclude="CheckoutPayment">
            <router-view :data="data" />
        </keep-alive>
    </div>
</template>

<script>
/* eslint-disable vue/script-indent */
// https://github.com/vuejs/vue-router/issues/916
import Loading from 'vue-loading-overlay';
import { mapActions, mapState } from 'vuex';
import getCurrentLanguage from '../../helpers/getCurrentLanguage.js';

export default {
    name: 'Checkout',
    props: {
        data: Object,
    },
    methods: {
        ...mapActions(['axiosGet', 'setMutation', 'getCsrf']),
    },
    async created() {
        this.$Progress.set(8);
        await this.setMutation({ mutation: 'SET_IS_LOADING', value: true });
        await this.axiosGet({
            mutation: 'SET_CURRENT_USER',
            api: `${getCurrentLanguage()}/api/users/current`,
        });
        await this.axiosGet({
            mutation: 'SET_PRODUCTS',
            api: `${getCurrentLanguage()}/api/products`,
        });
        await this.axiosGet({
            mutation: 'SET_GATEWAYS',
            api: `${getCurrentLanguage()}/api/gateways`,
        });
        await this.setMutation({ mutation: 'SET_IS_LOADING', value: false });
    },
    computed: {
        ...mapState(['isLoading', 'cart']),
    },
    watch: {
        $route(to) {
            if (to.name === 'checkout cart') {
                this.$Progress.set(8);
            }
            if (to.name === 'checkout addresses') {
                this.$Progress.set(50);
            }
            if (to.name === 'checkout payment') {
                this.$Progress.set(100);
            }
        },
    },
    components: {
        Loading,
    },
};
</script>
